<span class="click-to-copy" title="{{ isAllowToCopy() ? 'Click to copy' : '' }}" (click)="copyToClipboard($event)">
  <span [ngClass]="{ text: isAllowToCopy() }">{{ text }}</span>
</span>
